var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"hamburger",class:{ active: _vm.drawerOpen },attrs:{"type":"button","aria-expanded":_vm.drawerOpen ? 'true' : 'false',"aria-label":_vm.drawerOpen ? 'Close navigation menu' : 'Open navigation menu'},on:{"click":function($event){$event.preventDefault();return _vm.handleClick.apply(null, arguments)}}},[_c('span')])
}
var staticRenderFns = []

export { render, staticRenderFns }